// ContactSection.js
import React from "react";
import { FaPhoneAlt, FaMapMarkerAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import "./ContactUs.css"; // Importing CSS for styling

import contactImage from "../images/CUSTOMER-SERVICE.jpg"; // Replace with your actual contact image

const ContactSection = () => {
  return (
    <>



<div className="contact-hero-section" style={{ backgroundImage: `url(${contactImage})` }}>
      <div className="contact-hero-overlay">
        <div className="contact-hero-content">
          <h2 className="contact-hero-title">Contact Us</h2>
          <p className="contact-hero-description">
            Get in touch with <strong>Chennai Home Appliance Care</strong> for all your home appliance needs. We're here to help!
          </p>
          <button
            className="contact-btn"
            onClick={() => window.location.href = 'tel:+918270096596'}
          >
            Call Us Now:  82700 96596
          </button>
        </div>
      </div>
    </div>





    <div className="contact-section">
      <div className="contact-column">
        <h3>Phone Number</h3>
        <p><FaPhoneAlt /> +91 82700 96596</p>
        <p><FaPhoneAlt /> +91 82700 96596</p>
      </div>

      <div className="contact-column">
        <h3>Address</h3>
        <p><FaMapMarkerAlt /> No: 73A Bajanai Koil Street Thiruvalluvar Nagar Pammal <br/>Chennai -
        600075.</p>
      </div>

      <div className="contact-column">
        <h3>Social Media</h3>
        <a href="https://wa.me/82700 96596" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp /> WhatsApp
      </a>

      {/* Email Link */}
      <a href="mailto:chennaihomeappliancecare@gmail.com" target="_blank" rel="noopener noreferrer">
        <FaEnvelope /> Email
      </a>
      </div>

      

    </div>
    </>
    
  );
};

export default ContactSection;
